<template>
  <!-- 项目记录 -->
  <div id="project-record">
    <div class="project-record-title" v-if="projectRecordData.title">
      {{ projectRecordData.title }}
    </div>
    <div class="project-record-textarea">
      <textarea
        class="textarea"
        v-model="textarea"
        rows="5"
        :maxlength="200"
        placeholder="请在此处添加记录"
      ></textarea>
      <div
        class="project-record-button-out"
        v-if="!showStatus"
        @click="addProjectRecord"
      >
        添加
      </div>
      <div class="project-record-action-row" v-if="showStatus">
        <el-select
          class="status-select"
          v-model="status"
          placeholder="跟进状态"
          clearable
        >
          <el-option label="待再次沟通" value="待再次沟通"></el-option>
          <el-option label="已加微信" value="已加微信"></el-option>
          <el-option label="到店" value="到店"></el-option>
          <el-option label="预付定金" value="预付定金"></el-option>
        </el-select>
        <div class="project-record-button" @click="addProjectRecord">添加</div>
      </div>
    </div>
    <div class="project-record-list" v-if="projectRecordData.list.length > 0">
      <div
        class="project-record-item"
        v-for="(item, index) in projectRecordData.list"
        :key="index"
      >
        <div class="project-record-item-title">
          <div class="icon">
            <img :src="item.userIcon" alt="" />
            <div>{{ item.userName }}</div>
          </div>
          <div style="color: #909399">
            {{ item.gmtCreate }}
          </div>
        </div>
        <div class="project-record-item-content">
          <div class="content">{{ item.content }}</div>
          <div
            class="attachment"
            v-if="item.attachment"
            @click="showAttachment(item.attachment)"
          >
            查看附件
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    projectRecordData: {
      type: Object,
      default: () => ({}),
    },
    /**
     * 是否显示跟进状态选择框
     * 仅线索详情页需要传 true，其他页面不传或传 false
     */
    showStatus: {
      type: Boolean,
      default: false,
    },
    /**
     * 添加记录前的自定义校验函数
     * 返回 false 则中止添加，保留用户输入内容
     * 不传或传 null 则不执行前置校验，向后兼容
     */
    beforeAdd: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      textarea: "",
      status: "",
    };
  },
  methods: {
    /**
     * 添加项目记录
     * 当 showStatus 为 true 时，必须选择跟进状态才能提交
     * @author lcj
     * @date 2026-06-23
     */
    addProjectRecord() {
      if (this.showStatus && !this.status) {
        this.$message.error("请选择跟进状态");
        return;
      }
      if (this.beforeAdd && this.beforeAdd() === false) {
        return;
      }
      if (this.showStatus) {
        this.$emit("addProjectRecord", {
          content: this.textarea,
          status: this.status,
        });
      } else {
        this.$emit("addProjectRecord", this.textarea);
      }
      this.textarea = "";
      this.status = "";
    },
    /**
     * 查看附件
     * @param attachment 附件路径
     * @author lcj
     * @date 2026-06-23
     */
    showAttachment(attachment) {
      window.open(attachment.path, "_blank");
    },
  },
  mounted() {
    console.log("this.projectRecordData", this.projectRecordData);
  },
};
</script>

<style lang="less" scoped>
#project-record {
  width: 100%;
  font-size: 14px;
  .project-record-title {
    display: flex;
    align-items: center;
    width: 100%;
    height: 40px;
    font-size: 16px;
    border-bottom: 1px solid #d1d3d8;
    padding: 0 15px;
    box-sizing: border-box;
  }
  .project-record-textarea {
    position: relative;
    width: 100%;
    height: 25%;
    padding: 10px;
    box-sizing: border-box;
    .textarea {
      width: 100%;
      padding: 10px;
      box-sizing: border-box;
      border: 1px solid #d1d3d8;
      outline-color: #d1d3d8; // 鼠标聚焦边框颜色
      resize: none;
    }
    .project-record-button-out {
      position: absolute;
      right: 20px;
      bottom: 20px;
      padding: 5px 20px;
      font-size: 12px;
      border-radius: 3px;
      color: @baseColor;
      border: 1px solid @baseColor;
      &:hover {
        background-color: #f2f7ff;
        cursor: pointer;
      }
    }
    .project-record-action-row {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 8px;

      .status-select {
        width: 180px;
        /deep/ .el-input__inner {
          color: #000;
        }
        /deep/ .el-input__inner::placeholder {
          color: #000;
        }
      }

      .project-record-button {
        padding: 5px 20px;
        font-size: 12px;
        border-radius: 3px;
        color: @baseColor;
        border: 1px solid @baseColor;
        &:hover {
          background-color: #f2f7ff;
          cursor: pointer;
        }
      }
    }
  }
  .project-record-list {
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 10px 20px;
    box-sizing: border-box;
    .project-record-item {
      margin-bottom: 10px;
      border-bottom: 1px solid #d1d3d8;
      .project-record-item-title {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .icon {
          display: flex;
          align-items: center;
          img {
            width: 30px;
            height: 30px;
            border-radius: 50%;
            margin-right: 10px;
          }
        }
      }
      .project-record-item-content {
        display: flex;
        align-items: flex-end;
        width: 100%;
        display: flex;
        padding: 5px 40px;
        padding-right: 0;
        box-sizing: border-box;
        text-align: left;
        .content {
          width: 85%;
        }
        .attachment {
          width: 15%;
          color: @baseColor;
          cursor: pointer;
          text-align: right;
        }
      }
    }
  }
}
</style>
